<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link v-if="idPerfil == 18 || idPerfil == 20" to="/tramite-asignados">Trámites</router-link>
            <router-link v-else to="/tramite">Trámites</router-link> >
            <router-link :to="'/tramiteform/' + p_idTramite">
              Trámite {{ p_idTramite }}</router-link
            >
            > Atención médica N.º  <b>{{ datoPlanilla.numero }}</b>
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
            >help
          </span>
        </div>
      </div>
    </div>
<!--
    <Modal v-model:modelValue="showModalHelp">
      <AyudaTramiteForm />
    </Modal>
-->
    <hr />
    <!-- Modal -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="row">
            <div class="col-9" style="text-align: left">
              <div class="row">
                <div class="col-1">
                  <label class="form-label fw-bold">&nbsp;&nbsp;Cédula</label>
                </div>
                <div class="col-3">
                  <span>{{ datoPlanilla.cedula }}</span>
                </div>
                <div class="col-1">
                  <label class="form-label fw-bold">Nombre</label>
                </div>
                <div class="col-4">
                  <span>{{ datoPlanilla.nombre }}</span>
                </div>
              </div>
            </div>

            <div class="col-3" style="text-align: right">
              <button
                class="btn btn-outline-secondary d-inline-flex align-items-center gap-1"
                @click.prevent="mostrarOcultarBloque"
                style="
                  padding-top: 0.1rem;
                  padding-bottom: 0.1rem;
                  padding-left: 0.5rem;
                  padding-right: 0.5rem;
                "
              >
                <span class="material-icons" style="font-size: 1.1rem">
                  {{
                    mostrarBloque
                      ? "remove_circle_outline"
                      : "add_circle_outline"
                  }}
                </span>
                {{ mostrarBloque ? "Menos información" : "Más información" }}
              </button>
            </div>
          </div>
<br>
          <p v-if="esDiaSabado(datoPlanilla.fechaDesde)" class="texto-aviso">
            La fecha de atención corresponde a un día sábado
          </p>
          <p v-if="esDiaDomingo(datoPlanilla.fechaDesde)" class="texto-aviso">
            La fecha de atención corresponde a un día domingo
          </p>
          <div v-if="mostrarBloque" class="mb-3">
            <div class="modal-body">
              <div class="mb-1"></div>
<div class="mb-3" v-for="n in 5" :key="'diag' + n">
  <div class="row">
    <div class="col-1">
      <label :for="'diag' + n" class="form-label fw-bold">Diag {{ n }}</label>
    </div>

    <!-- SELECT de códigos -->
    <div class="col-2">
      <input type="text" class="form-control me-2" :id="'diag' + n" v-model="datoPlanilla['diag' + n]" :required="n < 3" readonly />
    </div>

    <!-- Mostrar descripción automáticamente -->
    <div class="col-7">
      <input
        type="text"
        class="form-control"
		v-model="nombre_diag[n]"
        disabled
      >
    </div>

    <!-- SELECT de códigos -->
    <div class="col-1">
<span 
  v-if="procesoAM"
  @click="abrirModalDiagnosticos('diag' + n)"
  data-bs-toggle="modal"
  data-bs-target="#ModalDiagnosticoLOV"
  title="Buscar diagnóstico"
  class="btn btn-outline-info d-inline-flex align-items-center justify-content-center rounded-circle"
  style="width: 40px; height: 40px; cursor: pointer;"
>
  <span class="material-symbols-outlined" style="font-size: 24px;">
    search
  </span>
</span>
    </div>

    <!-- Checkbox -->
<div class="col-1 d-flex align-items-center justify-content-center">
  <div class="form-check form-switch">
    <input
      v-if="procesoAM"
      class="form-check-input"
      type="checkbox"
      role="switch"
      v-model="datoPlanilla['controlDiag' + n]"
      :true-value="1"
      :false-value="0"
      :title="datoPlanilla['controlDiag' + n] === 1 ? 'Desactivar' : 'Activar'"
      @change="onToggleDiag(n)"
      v-bind="datoPlanilla['controlDiag' + n] === 0 ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#ModalDiagnosticoLOV' } : {}"
    >
  </div>
</div>
	
  </div>
</div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="idTramite" class="form-label fw-bold">Aut./Cod. Val.</label>
                  </div>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control"
                      id="idTramite"
                      name="idTramite"
                      v-model="datoPlanilla.codigoVal"
                    />
                  </div>
                </div>
              </div>

              <hr />
              <div class="mb-1">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha desde</label>
                    <input type="date"
                           class="form-control"
                           id="fechaDesde"
                           name="fechaDesde"
                           v-model="datoPlanilla.fechaDesde"
                           :min="getFormattedDateISO(datoPlanilla.fechaDesdeCarga)"
                           :max="getFormattedDateISO(datoPlanilla.fechaHastaCarga)"
                           required>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Hora desde</label><br />
                    <span>{{ datoPlanilla.horaDesde }}</span>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha hasta</label>
                    <input type="date"
                           class="form-control"
                           id="fechaHasta"
                           name="fechaHasta"
                           v-model="datoPlanilla.fechaHasta"
                           :min="getFormattedDateISO(datoPlanilla.fechaDesdeCarga)"
                           :max="getFormattedDateISO(datoPlanilla.fechaHastaCarga)"
                           required>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Hora hasta</label><br />
                    <span>{{ datoPlanilla.horaHasta }}</span>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Estado</label><br />
<!-- Estado Auditoría -->
<span v-if="consultaAM">{{ datoPlanilla.estadoAud }}</span>
&nbsp;
<button type="button" v-if="consultaAM" @click="marcarPendiente('estadoAud')"
 title="Restablecer a estado PENDIENTE">
<span class="material-symbols-outlined">
replay
</span>
</button>

<!-- Estado Documento -->
<span v-if="consultaGD">{{ datoPlanilla.estadoDoc }}</span>
&nbsp;
<button type="button" v-if="consultaGD" @click="marcarPendiente('estadoDoc')"
 title="Restablecer a estado PENDIENTE">
<span class="material-symbols-outlined">
replay
</span>
</button>
                  </div>
                  <div class="col-1">
                    <button
                      v-if="procesoAM||procesoGD"
                      type="button"
                      class="btn btn-outline-primary"
                      @click="guardarPlanilla()"
                      title="Actualizar"
                    >
                      <span class="material-symbols-outlined"
                            style="font-size: 32px; cursor: pointer">
                        update
                      </span>
                    </button>
                  </div>
                  <div class="col-1">
                    <button
                      class="btn btn-outline-danger"
                      @click="planillaPDF(datoPlanilla.idPlanilla)"
                      title="Generar archivo .pdf de la atención médica"
                    >
                      <span class="material-symbols-outlined"
                            style="font-size: 32px; cursor: pointer">
                        picture_as_pdf
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <!--     <h4>Seleccionar Plantilla</h4>
    <hr /> -->
              <div class="mb-1">
                <!-- <label for="plantillaSelect" class="form-label">Consultar y seleccionar una plantilla:</label> -->
                <div class="input-group">
                  <input
                    v-if="procesoAM"
                    type="text"
                    class="form-control"
                    v-model="searchText"
                    @input="filterPlantillas"
                    placeholder="Consultar plantilla..."
                  />
                  <select
                    v-if="procesoAM"
                    class="form-select"
                    id="plantillaSelect"
                    v-model="selectedPlantilla"
                  >
                    <option disabled value="">Seleccione una plantilla</option>
                    <option
                      v-for="plantilla in filteredPlantillas"
                      :key="plantilla.idPlantilla"
                      :value="plantilla"
                    >
                      {{ plantilla.nombre }}
                    </option>
                  </select>
                  <button
                    v-if="procesoAM"
                    type="button"
                    class="btn btn-primary"
                    @click="registrarElementos"
                    title="Aplicar plantilla"
                  >
                    <span class="material-symbols-outlined" style="font-size: 24px; cursor: pointer">add_circle</span> Plantilla
                  </button>
                  <button
                    v-if="procesoAM"
                    type="button"
                    class="btn btn-primary"
                    @click="eliminarElementos"
                    title="Quitar plantilla"
                  >
                    <span class="material-symbols-outlined" style="font-size: 24px; cursor: pointer">do_not_disturb_on</span> Plantilla
                  </button>
                  <button
                    v-if="procesoAM || procesoGD"
                    type="button"
                    class="btn btn-success"
                    @click="registrarRevision"
                    title="Aplicar revisión"
                  >
                    <span class="material-symbols-outlined" style="font-size: 24px; cursor: pointer">task_alt</span> Revisión
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <br />
    <!-- Estructura de Tabs -->
    <div class="tabs">
      <button
        class="tablink"
        @click="showTable = 'planilladet'"
        :class="{ 'active-tab': showTable === 'planilladet' }"
      >
        <span class="material-symbols-outlined"> stacks </span>
        Detalle
      </button>
      <button
        class="tablink"
        @click="showTable = 'archivopla'"
        :class="{ 'active-tab': showTable === 'archivopla' }"
      >
        <span class="material-symbols-outlined"> description </span>
        Archivos
      </button>
      <button
        v-if="consultaAM"
        class="tablink"
        @click="showTable = 'observacionAM'"
        :class="{ 'active-tab': showTable === 'observacionAM' }"
      >
        <span class="material-symbols-outlined"> clinical_notes </span>
        Observaciones de Auditoría Médica
      </button>
      <button
        v-if="consultaGD"
        class="tablink"
        @click="showTable = 'observacionGD'"
        :class="{ 'active-tab': showTable === 'observacionGD' }"
      >
        <span class="material-symbols-outlined"> clinical_notes </span>
        Observaciones de Gestión Documental
      </button>
      <button
        class="tablink"
        @click="showTable = 'otrasAtenciones'"
        :class="{ 'active-tab': showTable === 'otrasAtenciones' }"
      >
        <span class="material-symbols-outlined"> folder_copy </span>
        Otras atenciones
      </button>
      <button
        v-if="supervisorAM"
        class="tablink"
        @click="showTable = 'auditoriaPlanilla'"
        :class="{ 'active-tab': showTable === 'auditoriaPlanilla' }"
      >
        <span class="material-symbols-outlined"> folder_copy </span>
        Inf. auditoría
      </button>
      <button
        v-if="supervisorAM"
        class="tablink"
        @click="showTable = 'planilladetact'"
        :class="{ 'active-tab': showTable === 'planilladetact' }"
      >
        <span class="material-symbols-outlined"> toggle_off </span>
        Activar detalle
      </button>
      <!--
      <button class="tablink" @click="showTable = 'planilladoc'" :class="{ 'active-tab': showTable === 'planilladoc' }">
        Documentos
      </button>
 -->
    </div>

    <!-- Contenido dinámico según la pestaña seleccionada -->
    <div v-if="showTable === 'planilladet'">
      <PlanillaDet
        :p_idTramite="Number(p_idTramite)"
        :p_idPrestador="Number(datoPlanilla.idPrestador)"
        :p_estadoTramite="p_estadoTramite"
        :p_idPlanilla="Number(p_idPlanilla)"
        :p_numero="datoPlanilla.numero"
        :p_fechaDesde="normalizeDate(datoPlanilla.fechaDesde)"
        :p_fechaHasta="normalizeDate(datoPlanilla.fechaHasta)"
        :p_tipo="'M'"
        :p_procesoAM="procesoAM"
        :p_procesoGD="procesoGD"
      >
      </PlanillaDet>
      <ArchivoPla 
        :p_idTramite="Number(p_idTramite)"
        :p_idPlanilla="Number(p_idPlanilla)"></ArchivoPla>
    </div>
    <div v-if="showTable === 'archivopla'">
      <ArchivoPlaDatos
      :p_idTramite="Number(p_idTramite)"
      :p_idPlanilla="Number(p_idPlanilla)"></ArchivoPlaDatos>
    </div>
    <div v-if="showTable === 'observacionAM'">
      <PlaObs
        :p_idPlanilla="Number(p_idPlanilla)"
        :p_tipo="'M'"
        :p_procesoAM="procesoAM"
        :p_procesoGD="procesoGD"
      ></PlaObs>
    </div>
    <div v-if="showTable === 'observacionGD'">
      <PlaObs
        :p_idPlanilla="Number(p_idPlanilla)"
        :p_tipo="'D'"
        :p_procesoAM="procesoAM"
        :p_procesoGD="procesoGD"
      ></PlaObs>
    </div>
    <div v-if="showTable === 'otrasAtenciones'">
      <PlanillaInfo
        :idPrestador="Number(idEmpresa)"
        :idEspecialidad="1"
        :cedula="datoPlanilla.cedula"
      ></PlanillaInfo>
    </div>
    <div v-if="showTable === 'auditoriaPlanilla'">
      <ConsultaAuditoriaPlanilla
        :idPlanilla="Number(datoPlanilla.idPlanilla)"
      ></ConsultaAuditoriaPlanilla>
    </div>
    <div v-if="showTable === 'planilladetact'">
      <PlanillaDetAct
        :p_idTramite="Number(p_idTramite)"
        :p_idPrestador="Number(datoPlanilla.idPrestador)"
        :p_estadoTramite="p_estadoTramite"
        :p_idPlanilla="Number(p_idPlanilla)"
        :p_numero="datoPlanilla.numero"
        :p_tipo="'M'"
        :p_procesoAM="procesoAM"
        :p_procesoGD="procesoGD"
      >
      </PlanillaDetAct>
    </div>
    <!--
    <div v-if="showTable === 'planilladoc'">
      <PlanillaDoc :p_idPlanilla="p_idPlanilla"></PlanillaDoc>
    </div>
 -->
      <DiagnosticoLOV @DatosDiagnostico="asignarDiagnostico" />
    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import { esSabado, esDomingo } from "@/modules/dateUtils.js";
import { registrarBitacoraTramite } from "@/modules/bitacoraTramite.js";
import PlanillaDet from "../forms/PlanillaDet.vue";
import PlanillaDetAct from "../forms/PlanillaDetAct.vue";
import ArchivoPla from "../forms/ArchivoPla.vue";
import ArchivoPlaDatos from "../forms/ArchivoPlaDatos.vue";
import PlanillaInfo from "../forms/PlanillaInfo.vue";
import PlaObs from "../forms/PlaObs.vue";
import ConsultaAuditoriaPlanilla from '@/views/reportes/ConsultaAuditoriaPlanilla.vue';
//import PlanillaDoc from '../forms/PlanillaDoc.vue';
import DiagnosticoLOV from "@/components/lovs/DiagnosticoLOV.vue";
//import { format } from 'date-fns';

import Swal from "sweetalert2";
import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
export default {
  components: {
    Layout,
    Footer,
    PlanillaDet,
    PlanillaDetAct,
    ArchivoPla,
    ArchivoPlaDatos,
    PlaObs,
    PlanillaInfo,
	ConsultaAuditoriaPlanilla,
    DiagnosticoLOV
  },
  data() {
    return {
      planillas: [],
      datoPlanilla: {},
      nombreBusqueda: "",
      titulo: "",
      modalWindow: true,
      p_idTramite: 0,
      p_estadoTramite: 0,
      p_idPlanilla: 0,
      idPerfil: 0,
      idUsuario: 0,
      showTable: "", // Pestaña por defecto
      tramites: [],
    nombre_diag: {
      1: null,
      2: null,
      3: null,
      4: null,
      5: null
    },
/*	
      nombre_diag_1: null,
      nombre_diag_2: null,
      nombre_diag_3: null,
      nombre_diag_4: null,
      nombre_diag_5: null,
*/
      filteredPlantillas: [], // Lista filtrada según la búsqueda
      searchText: "", // Texto de búsqueda
      selectedPlantilla: null, // Plantilla seleccionada
      mensaje: "",
      success: false,
      mostrarBloque: true,
      pendientesRevision: 0,
      tipo: "",
      idEmpresa: 0,
//      diagnosticos: [],
      campoDiagnosticoActivo: ''
    };
  },
  computed: {
    supervisorAM() {
      return (
        (this.idPerfil == 17) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    consultaAM() {
      return (
        (this.idPerfil == 17 || this.idPerfil == 18) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    consultaGD() {
      return (
        (this.idPerfil == 19 || this.idPerfil == 20) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    procesoAM() {
      return (
        (this.idPerfil == 17 ||
          (this.idPerfil == 18 &&
            this.idUsuario == this.datoPlanilla.idUsuarioMed)) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    procesoGD() {
      return (
        (this.idPerfil == 19 ||
          (this.idPerfil == 20 &&
            this.idUsuario == this.datoPlanilla.idUsuarioDoc)) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    AM_GD() {
      return (
        (this.idPerfil == 17 ||
          this.idPerfil == 18 ||
          this.idPerfil == 19 ||
          this.idPerfil == 20) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
  },
  mounted() {
    this.p_idTramite = this.$route.params.p_idtramite;
    this.p_estadoTramite = this.$route.params.p_estadotramite;
    this.p_idPlanilla = this.$route.params.p_idplanilla;
    this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
    this.idPerfil = window.sessionStorage.getItem("idPerfil");
    this.idUsuario = window.sessionStorage.getItem("idUsuario");
    this.tipo = this.idPerfil == 17 || this.idPerfil == 18 ? "M" : "D";
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchPlantillas(); // Llamar al método para obtener los datos
//    this.obtenerDiagnosticos();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getFormattedDateISO(date) {
      return dateFormat.getFormattedDateISO(date);
    },
    normalizeDate(dateString) {
      // Asegura que la fecha sea un objeto Date con hora 00:00:00 en GMT-5
      const [year, month, day] = dateString.split('-');
      return new Date(`${year}-${month}-${day}T00:00:00.000-05:00`);
    },
    esDiaSabado(fecha) {
      return esSabado(fecha);
    },
    esDiaDomingo(fecha) {
      return esDomingo(fecha);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    async getData() {
      await api.get("/vwplanillaexts/" + this.p_idPlanilla)
        .then((response) => {
          this.datoPlanilla = response.data;
          this.datoPlanilla.fechaDesde = dateFormat.getFormattedDateISO(
            this.datoPlanilla.fechaDesde
          );
          this.datoPlanilla.fechaHasta = dateFormat.getFormattedDateISO(
            this.datoPlanilla.fechaHasta
          );
          this.fetchDiagnosticos();
          //          console.log("esDiaSabado(datoPlanilla.fechaDesde): "+this.esDiaSabado(this.datoPlanilla.fechaDesde));
        })
        .catch((error) => {
          console.error("Error al obtener datos de la persona:", error);
        });
    },
    validarForm() {
      const requiredFields = [
        "idTramite",
        "numero",
        "cedula",
        "nombre",
        "diag1",
        "diag2",
        "fechaDesde",
        "fechaHasta",
        "estadoAud",
      ];
      const requiredFieldsText = [
        "idTramite",
        "numero",
        "cedula",
        "nombre",
        "diag1",
        "diag2",
        "fechaDesde",
        "fechaHasta",
        "estadoAud",
      ];
      return validarForm(this.datoPlanilla, requiredFields, requiredFieldsText);
    },
    async guardarPlanilla(){
      if(this.validarForm() === 1){
        try {
          this.datoPlanilla.idUsuarioAct = this.idUsuario;
          this.datoPlanilla.fechaAct = new Date();
          await api.post('/planillas', this.datoPlanilla)
          Swal.fire("Éxito", "Planilla actualizada exitosamente!", "success");
        } catch (error) { 
          Swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async fetchNombreDiagnostico(codigo) {
      try {
        const response = await api.get(`/vwdiagnosticos/codigo-sin-punto/${codigo}`
        );

        // Asegúrate de que la respuesta contiene datos y es un array
        const diagnosticos = response.data;

        if (Array.isArray(diagnosticos) && diagnosticos.length > 0) {
          const nombre = diagnosticos[0].nombre; // Accede al 'nombre' del primer elemento
          return nombre;
        } else {
          //          console.error(`CONTROL: No se encontraron diagnósticos para el código ${codigo}`);
          return "Diagnóstico no encontrado";
        }
      } catch (error) {
        //        console.error(`Error al obtener el diagnóstico para el código ${codigo}`, error);
        return "Error al cargar";
      }
    },
    async fetchDiagnosticos() {
      const codigos = [
        this.datoPlanilla.diag1,
        this.datoPlanilla.diag2,
        this.datoPlanilla.diag3,
        this.datoPlanilla.diag4,
        this.datoPlanilla.diag5,
      ];

      const nombres = await Promise.all(
        codigos.map((codigo) =>
          codigo ? this.fetchNombreDiagnostico(codigo) : null
        )
      );

      this.nombre_diag[1] = nombres[0];
      this.nombre_diag[2] = nombres[1];
      this.nombre_diag[3] = nombres[2];
      this.nombre_diag[4] = nombres[3];
      this.nombre_diag[5] = nombres[4];
    },

    // Obtener las plantillas desde el servidor
    fetchPlantillas() {
      api.get(`/vwplantillas/idempresa/${this.idEmpresa}`)
        .then((response) => {
          this.plantillas = response.data;
          this.filteredPlantillas = response.data; // Inicializar la lista filtrada
        })
        .catch((error) => {
          console.error("Error fetching plantillas:", error);
        });
    },

    // Filtrar plantillas según el texto ingresado
    filterPlantillas() {
      this.filteredPlantillas = this.plantillas.filter((plantilla) =>
        plantilla.nombre.toLowerCase().includes(this.searchText.toLowerCase())
      );
    },
    async registrarElementos() {
      if (this.datoPlanilla.idPlantilla == null) {
        if (this.selectedPlantilla != null) {
          try {
            const response = await api.post("/planillas/registrar-elementos-plantilla",
              null,
              {
                params: {
                  idPlanilla: this.p_idPlanilla,
                  idPlantilla: this.selectedPlantilla.idPlantilla,
                },
              }
            );
            this.getData();
            Swal.fire("Éxito", response.data, "success");
          } catch (error) {
            const message =
              error.response?.data ||
              "Ocurrió un error al realizar la operación.";
            Swal.fire("Error", message, "error");
          }
        } else {
          Swal.fire({
            title: "Atención",
            text: "Por favor, seleccione una plantilla antes de continuar.",
            icon: "warning",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#f39c12",
          });
        }
      } else {
        Swal.fire({
          title: "Atención",
          text: "La planilla ya tiene asignada una plantilla.",
          icon: "warning",
          confirmButtonText: "Entendido",
          confirmButtonColor: "#f39c12",
        });
      }
    },
    async eliminarElementos() {
      if (this.datoPlanilla.idPlantilla != null) {
        try {
          const response = await api.post("/planillas/eliminar-elementos-plantilla",
            null,
            {
              params: {
                idPlanilla: this.p_idPlanilla,
              },
            }
          );
          this.getData();
          Swal.fire("Éxito", response.data, "success");
        } catch (error) {
          const message =
            error.response?.data ||
            "Ocurrió un error al realizar la operación.";
          Swal.fire("Error", message, "error");
        }
      } else {
        Swal.fire({
          title: "Atención",
          text: "Esta planilla no tiene una plantilla asignada que pueda ser eliminada.",
          icon: "warning",
          confirmButtonText: "Entendido",
          confirmButtonColor: "#f39c12",
        });
      }
    },

    async registrarRevision() {
	if(this.validarForm() === 1){
      try {
        const idPerfil = Number(window.sessionStorage.getItem("idPerfil"));

        // Inicializar las variables con valores nulos
        let actividad = null;
//        let fase = null;

        if ([17, 18].includes(idPerfil)) {
          actividad = "M";
//          fase = "F1";
          this.datoPlanilla.estadoAud = "REVISADA";
          this.datoPlanilla.idUsuarioMed = this.idUsuario;
          this.datoPlanilla.fechaAud = new Date();
        } else if ([19, 20].includes(idPerfil)) {
          actividad = "D";
//          fase = "F2";
          this.datoPlanilla.estadoDoc = "REVISADA";
          this.datoPlanilla.idUsuarioDoc = this.idUsuario;
          this.datoPlanilla.fechaDoc = new Date();
        } else {
          Swal.fire("Error!", "Perfil no autorizado para esta acción", "error");
          return;
        }

        // Registrar planilla
        await api.post("/planillas",
          this.datoPlanilla
        );

        // Verificar que actividad y fase no sean null antes de usarlos

        if (actividad) {
          await registrarBitacoraTramite(
            this.p_idTramite,
            `Planilla: ${this.datoPlanilla.numero}, Paciente: ${this.datoPlanilla.nombre}`,
            actividad
          );
        }
/*
        await this.obtenerPendientesRevision(actividad);

        if (this.pendientesRevision === 0 && fase) {
          this.actualizarFechas(this.datoPlanilla.idCarga, actividad);
          await registrarBitacoraTramite(
            this.p_idTramite,
            `${window.sessionStorage.getItem(
              "usuario"
            )} - ${window.sessionStorage.getItem("nombrePersona")}`,
            fase
          );
        }

        const mensajePendientes =
          this.pendientesRevision > 0
            ? `Planilla revisada exitosamente!<br>Quedan <b>${this.pendientesRevision}</b> planillas por revisar`
            : `Planilla revisada exitosamente!<br>No quedan planillas por revisar`;

        await Swal.fire({
          icon: "success",
          title: "Correcto!",
          html: mensajePendientes,
          showConfirmButton: this.pendientesRevision === 0,
          timer: this.pendientesRevision > 0 ? 2000 : undefined,
        });
*/
//        if (this.pendientesRevision > 0) {
          this.abrirSiguiente(actividad);
//        }
      } catch (error) {
        console.error("Error en registrarRevision:", error);
        Swal.fire("Error!", error.response?.data || error.message, "error");
      }
	}
    },

    async obtenerPendientesRevision(actividad) {
      try {
        const endpoint =
          actividad === "M"
            ? "pendientes-am"
            : actividad === "D"
            ? "pendientes-gd"
            : null;

        if (!endpoint) {
          console.error("Error: Actividad no válida");
          return;
        }

        const response = await api.get(`/vwtramites/${this.p_idTramite}/${this.datoPlanilla.idCarga}/${endpoint}`
        );

        this.pendientesRevision = response.data;
      } catch (error) {
        console.error("Error obteniendo pendientes de revisión:", error);
      }
    },

    async abrirSiguiente(actividad) {
      try {
        const endpoint =
          actividad === "M"
            ? "siguiente-pendiente-am"
            : actividad === "D"
            ? "siguiente-pendiente-gd"
            : null;

        if (!endpoint) {
          console.error("Error: Actividad no válida");
          return;
        }

        const response = await api.get(`/planillas/${endpoint}/${this.p_idTramite}/${this.datoPlanilla.idCarga}`
        );

        const idPlanilla = response.data;
        if (idPlanilla != null) {
          this.$router
            .push(
              `/planillaform/${this.p_idTramite}/${this.p_estadoTramite}/${idPlanilla}`
            )
            .then(() => {
              window.location.reload(); // Recarga la página después de navegar
            });
        }
} catch (error) {
  console.error("Error en registrarRevision:", error);
  if (error.response && error.response.status === 404) {
    Swal.fire({
      title: "Sin planillas pendientes",
      text: "No se encontraron planillas pendientes para este trámite y carga.",
      icon: "warning",
      confirmButtonText: "Aceptar"
    });
  } else {
    Swal.fire({
      title: "Error",
      text: error.response?.data?.message || error.message || "Error al registrar la revisión",
      icon: "error",
      confirmButtonText: "Aceptar"
    });
  }
}
    },

    async actualizarFechas(idCarga, actividad) {
      let url = "";

      if (actividad === "M") {
        url = `/planillas/actualizarFechasAM/${idCarga}`;
      } else if (actividad === "D") {
        url = `/planillas/actualizarFechasGD/${idCarga}`;
      } else {
        console.error("Actividad no válida. Use 'M' o 'D'");
        return;
      }

      try {
        const response = await api.put(url);
        console.log("Respuesta del servidor:", response.data);
      } catch (error) {
        console.error(
          "Error al actualizar fechas:",
          error.response?.data || error.message
        );
      }
    },
    abrirReporte(tipo, p_idTramite) {
      const url = `${config.apiBaseUrl}/reportes/pdf/${tipo}/${p_idTramite}`;
      window.open(url, "_blank");
    },
    planillaPDF(p_idPlanilla) {
      this.abrirReporte(1, p_idPlanilla);
    }, 
  abrirModalDiagnosticos(campo) {
    this.campoDiagnosticoActivo = campo;
  },
  asignarDiagnostico(diagnostico) {
    if (this.campoDiagnosticoActivo) {
      this.datoPlanilla[this.campoDiagnosticoActivo] = diagnostico.codigo;
      const num = this.campoDiagnosticoActivo.replace('diag', '');
      this.nombre_diag[num] = diagnostico.nombre;
    }
  },
  onToggleDiag(n) {
    const control = this.datoPlanilla['controlDiag' + n];
    if (control === 1) {
      this.seleccionar(n);
    } else {
      this.borrar(n);
    }
  },

  seleccionar(n) {
    this.abrirModalDiagnosticos('diag' + n);
    console.log('Seleccionar diagnóstico', n);
  },

  borrar(n) {
    this.datoPlanilla['diag' + n] = null;
	this.nombre_diag[n] = null;
    console.log('Borrar diagnóstico', n);
  },

  marcarPendiente(campo) {
    this.datoPlanilla[campo] = 'PENDIENTE';
  }
  },
};
</script>

<style src="@/assets/css/tabs.css" scoped></style>

<style scoped>
.input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>

<style scoped>
.btn {
  font-size: 16px;
  padding: 10px 20px;
}

.alert {
  margin-top: 20px;
  padding: 10px;
  border-radius: 5px;
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
<style scoped>
.texto-rojo {
  color: red;
  font-weight: bold; /* Negrilla */
  background-color: #ffe5b4; /* Fondo amarillo */
}
.texto-aviso {
  color: #b30000; /* Rojo suave, más elegante que "red" puro */
  font-weight: 600; /* Negrilla moderada */
  background-color: #fff3cd; /* Fondo cálido tipo alerta suave */
  padding: 8px 12px;
  border-radius: 6px;
  border-left: 4px solid #f0ad4e; /* Detalle visual */
  font-size: 14px;
}
</style>
